import styled from "styled-components";
import { colors, values, text } from "~/assets/js/theme/constants";
import { disableMouseEvents } from "~/assets/js/theme/mixins";

const margin = 20;
export const WIDGET_HEIGHT = 254;
const width = 216;

export const WidthEnsurer = styled.div`
    width: ${width}px;
    white-space: nowrap;
`;

export const WidgetContainer = styled.div`
    ${(props) => {
        if (props.soldOut) {
            return `
                ${disableMouseEvents}
                `;
        }
        return "";
    }}
    width: ${width}px;
    height: ${WIDGET_HEIGHT}px;
    border-radius: ${values.BORDER_RADIUS}px;
    background-color: ${(props) =>
        props.widgetState === "add"
            ? colors.LAYOUT.GRAY[100]
            : colors.BRAND.PRIMARY[100]};
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${margin + 50}px 0 0 ${margin}px;

    cursor: ${(props) => (props.amount > 1 ? "default" : "pointer")};
    transform: scale(1);
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    &:hover {
        transform: scale(${(props) => (props.amount > 1 ? "1" : "1.005")});
    }

    border: 2px solid
        ${(props) =>
            props.widgetState === "add"
                ? colors.LAYOUT.GRAY[100]
                : colors.BRAND.PRIMARY[1000]};
`;

export const TopImageContainer = styled.div`
    width: 100px;
    height: 100px;
    border-radius: ${(props) => (props.transparentImage ? 0 : 50)}px;
    margin-top: -100px;
    ${(props) =>
        props.transparentImage ? "" : `box-shadow: 0px 14px 32px #00000030;`}
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    color: ${colors.LAYOUT.GRAY[1000]};
    font-size: 40px;
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    &.visible {
        ${(props) =>
            props.transparentImage
                ? ""
                : `background-color: rgba(255, 255, 255, 0.7);`}
    }
`;

export const TopImage = styled.div`
    width: 100px;
    height: 100px;
    ${(props) =>
        props.transparentImage && !props.soldOut
            ? `filter: drop-shadow(0px 14px 32px #00000030);`
            : ""}
    border-radius: ${(props) => (props.transparentImage ? 0 : 50)}px;
    margin-top: -50px;
    justify-content: space-between;
    background-size: ${(props) =>
        props.transparentImage ? "contain" : "cover"};
    background-repeat: no-repeat;
    background-position: center;
`;

export const StyledIconButton = styled.div`
    opacity: 0;
    transform: scale(0);
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    &.visible {
        opacity: 1;
        transform: scale(1);
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 90px;
`;

export const Name = styled.div`
    text-align: center;
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    font-size: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    white-space: normal;
`;

export const Data = styled.div`
    text-align: center;
    font-size: 14px;
    opacity: 0.7;
    font-family: ${text.REGULAR.FONT};
    font-weight: ${text.REGULAR.WEIGHT};
`;

export const Symbols = styled.div`
    margin-top: 14px;
    padding: 4px 4px 8px 0;
    display: flex;
    flex-direction: row;
    overflow: visible;
    img {
        width: 24px;
        margin: 4px;
        overflow: visible;
    }
`;

const padding = 14;

export const Footer = styled.div`
    left: ${padding}px;
    right: ${padding}px;
    bottom: ${padding}px;
    padding-top: 10px;
    position: absolute;
    border-top: 1px solid ${colors.LAYOUT.GRAY[300]};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    line-height: 1;
    font-size: 18px;
`;

const SOLD_OUT_BACKDROP_COLOR = `${colors.BLACK}60`;
const SOLD_OUT_BACKDROP_BLUR = 2;

export const SoldOutBackdrop = styled.div`
    background-color: ${SOLD_OUT_BACKDROP_COLOR};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: absolute;
    border-radius: ${values.BORDER_RADIUS}px;
    backdrop-filter: blur(${SOLD_OUT_BACKDROP_BLUR}px);
`;

export const SoldOut = styled.div`
    text-transform: uppercase;
    text-shadow: 0 0 20px ${SOLD_OUT_BACKDROP_COLOR};
    overflow: hidden;
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    font-size: 21px;
    color: ${colors.WHITE};
    position: absolute;
    top: 0;
    bottom: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    letter-spacing: 1px;
`;

export const SoldOutTopImage = styled.div`
    overflow: hidden;
    background-color: ${SOLD_OUT_BACKDROP_COLOR};
    height: 50%;
    width: 100%;
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    backdrop-filter: blur(${SOLD_OUT_BACKDROP_BLUR}px);
`;
